@if (userLoading()) {
   <div class="user-loader skeleton-loader rounded-circle"></div>
}

@if (!userLoading() && !userError() && user(); as userData) {
   <div class="user-dropdown position-relative d-inline-block">
      <button (click)="toggleUserDropdown()" class="rounded-circle p-2 border bg-light d-flex align-items-center justify-content-center user-dropdown-btn" aria-label="Toggle user menu">
         <img src="/assets/images/header/user.svg" class="img-fluid" alt="user">
      </button>
      <div class="p-2 border shadow mt-2 user-dropdown-menu position-absolute end-0 top-100" [hidden]="!isUserDropdownOpen()">
         <header class="user-dropdown-header d-flex align-items-center gap-2 p-2">
            <div class="rounded-circle me-1 d-flex flex-shrink-0 align-items-center justify-content-center fw-600 user-avatar">
               {{ userData.firstname.charAt(0).toUpperCase() }}
            </div>
            <div class="flex-grow-1">
               <h6 class="mb-1 lh-sm text-truncate">{{ userData.firstname + ' ' + userData.lastname }}</h6>
               <span class="d-block text-truncate lh-sm user-email">
                  {{ userData.email }}
               </span>
            </div>
         </header>

         <hr class="my-2">

         @if (isCountryChangeOptionVisible()) {
            <div>
               <app-header-countries-dropdown class="flex-grow-1"></app-header-countries-dropdown>
            </div>
         }

         <button (click)="navigateTo('/user')" class="text-dark text-decoration-none text-start w-100 d-flex align-items-center gap-2 p-2 border-0 dropdown-action-btn">
            <img src="/assets/images/header/icon-account-setting.svg" width="20" height="20" class="img-fluid" alt="Profile">
            <span>Profile Details</span>
         </button>

         <button (click)="goToInvesterDashboard()" class="text-dark text-decoration-none text-start w-100 d-flex align-items-center gap-2 p-2 border-0 dropdown-action-btn">
            <img src="/assets/images/header/icon-money-bag.svg" width="20" height="20" class="img-fluid" alt="Investments">
            <span>My Musaffa Investments</span>
         </button>

         <button (click)="navigateTo('/stock-requests')" class="text-dark text-decoration-none text-start w-100 d-flex align-items-center gap-2 p-2 border-0 dropdown-action-btn">
            <img src="/assets/images/header/icon-stock-request.svg" width="20" height="20" class="img-fluid" alt="Stock Requests">
            <span>My Stock Requests</span>
         </button>

         <button (click)="navigateTo('/user/support')" class="text-dark text-decoration-none text-start w-100 d-flex align-items-center gap-2 p-2 border-0 dropdown-action-btn">
            <img src="/assets/images/header/icon-mail.svg" width="20" height="20" class="img-fluid" alt="Support">
            <span>Get in touch</span>
         </button>

         <hr class="my-2">

         <button (click)="logout()" class="text-danger text-decoration-none text-start w-100 d-flex align-items-center gap-2 p-2 border-0 dropdown-action-btn">
            <img src="/assets/images/header/icon-logout.svg" width="20" height="20" class="img-fluid" alt="Logout">
            <span>Logout</span>
         </button>
      </div>
   </div> 
}
